// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3KZhU","tab":"ProcedureTabs_tab__1iav6"};